import { useState, useEffect } from "react";
import { Wrench } from "lucide-react";
import SEO from "../components/SEO";

const MaintenancePage = ({ message, expiresAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    if (!expiresAt) return;

    const updateTimer = () => {
      const now = new Date();
      const expires = new Date(expiresAt);
      const diff = expires - now;

      if (diff <= 0) {
        setTimeLeft("Any moment now...");
        // Reload page to check if maintenance is over
        setTimeout(() => window.location.reload(), 5000);
        return;
      }

      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      
      if (minutes > 0) {
        setTimeLeft(`~${minutes} minute${minutes !== 1 ? 's' : ''} remaining`);
      } else {
        setTimeLeft(`~${seconds} second${seconds !== 1 ? 's' : ''} remaining`);
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  return (
    <div style={{
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #1B4D3E 0%, #2D6A4F 50%, #40916C 100%)",
      padding: "2rem",
      textAlign: "center"
    }}>
      <SEO title="Maintenance" description="PlayMahjong.in is currently undergoing maintenance. We'll be back shortly." noindex />
      <div style={{
        background: "white",
        borderRadius: "16px",
        padding: "3rem 2rem",
        maxWidth: "500px",
        width: "100%",
        boxShadow: "0 10px 40px rgba(0,0,0,0.2)"
      }}>
        <div style={{
          width: "80px",
          height: "80px",
          background: "#F5F7F5",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 auto 1.5rem"
        }}>
          <Wrench size={40} color="#1B4D3E" />
        </div>

        <h1 style={{
          fontSize: "1.75rem",
          fontWeight: "700",
          color: "#1B4D3E",
          marginBottom: "1rem"
        }}>
          We'll Be Right Back
        </h1>

        <p style={{
          fontSize: "1rem",
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "1.5rem"
        }}>
          {message || "We're updating the site. We'll be back in a few minutes!"}
        </p>

        {timeLeft && (
          <div style={{
            background: "#F5F7F5",
            padding: "0.75rem 1.5rem",
            borderRadius: "25px",
            display: "inline-block"
          }}>
            <span style={{
              fontSize: "0.9rem",
              color: "#1B4D3E",
              fontWeight: "600"
            }}>
              {timeLeft}
            </span>
          </div>
        )}

        <p style={{
          marginTop: "2rem",
          fontSize: "0.85rem",
          color: "#999"
        }}>
          This page will automatically refresh when we're back online.
        </p>
      </div>

      <div style={{
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        gap: "0.5rem"
      }}>
        <span style={{ fontSize: "1.5rem" }}>🀄</span>
        <span style={{
          color: "white",
          fontWeight: "600",
          fontSize: "1.1rem"
        }}>
          PlayMahjong.in
        </span>
      </div>
    </div>
  );
};

export default MaintenancePage;
